$("#truck-modal").click(function () {$("#truck-comtainer-modal").css({"display": "block"})});
$("#truck-modal-mobile").click(function () {$("#truck-comtainer-modal").css({"display": "block"})});
$(".truck-icon-item").click(function () {$("#truck-comtainer-modal").css({"display": "none"})});

$(window).resize(function(){
  generarSliders()
});
$(function(){
    generarSliders()
})


 
function generarSliders(){
    widthWindow = document.documentElement.clientWidth;
    const $el = $("#slidershow-container");
    const height = $el.height();
    const width = $(window).width();
    if(width <= 700) $el.height(width);
    else $el.height("auto");
    if (widthWindow <= 520) { 

        /** */
        try {
            $('.lista-imagenes').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                settings: {
                    arrows: true,
                }
            });
       
            $('.slider-mobile').slick({
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                settings: {
                    arrows: true,
                }
            }); 
            $('.promo-slider').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                settings: {
                    arrows: true,
                }
            }); 
            $.each($(".lista-iconos"), function (index, key) {

                let itemsRow = $(this).attr("data-items")


                $(this).slick({
                    infinite: true,
                    slidesToShow: itemsRow,
                    slidesToScroll: 1,
                    settings: {
                        arrows: true,
                    }
                });
            })
        } catch (error) {
            setTimeout(() => {
                
            }, 100);
        }
        $.each($(".cambioImagenMobile"), function (index, key) {
 
            let imgMobile = $(this).attr("data-bgmobile"); 
            $(this).css("background-image",'url("'+ imgMobile+' ")')
        })
        /**/
    } else {
        try {

            $('.lista-imagenes,.slider-mobile,.promo-slider,.lista-iconos').slick('unslick');
        } catch (error) {

        }
    }
}

setTimeout(function () {
    const $el = $("#slidershow-container");
    const height = $el.height();
    const width = $(window).width();
    if(width <= 700) $el.height(width);
    else $el.height("auto");
    
    $("button[class='flickity-button flickity-prev-next-button next']").append("<img alt='Next' src='//bebesit.cl/cdn/shop/t/173/assets/Copy%20of%20WFLECHAI.png?v=130242628817836378511780274437' >");
    $("button[class='flickity-button flickity-prev-next-button previous']").append("<img alt='Previous' src='//bebesit.cl/cdn/shop/t/173/assets/Copy%20of%20WFLECHAD.png?v=79995401687084863011780274437' >");
},500)


$(".site-header-button.site-header-menu-button").on("click",function(){
    $(".site-mobile-nav").addClass("visible");

})

$(".close-icon-burger").on("click",function(){
  $(".site-mobile-nav").removeClass("visible");
  $(".template-index").removeClass("scroll-lock");
})
